import React, {useCallback, useMemo, useState} from "react";
import CountryLanguage from "@ladjs/country-language";
import {ArrowDropDown, Language} from "@mui/icons-material";
import {Button, IconButton, Menu, MenuItem, Tooltip} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {getLanguageTranslations} from "../../translations/getLanguageTranslations";
import {appConfigSelector} from "../../state/app-config/appConfigSelectors";
import {languagesSelector} from "../../state/app/appSelectors";
import {themeConfigShowLangsAsTextSelector} from "../../state/theme-config/themeConfigSelectors";

export const I18N_ADORNMENT_VIEW_MODE_ICON = "icon";
export const I18N_ADORNMENT_VIEW_MODE_ICONTEXT = "icontext";
export const I18N_ADORNMENT_VIEW_MODE_TEXT = "text";

const I18nInputAdornmentSelect = ({value, onChange, ariaLabel, tooltip, viewMode: viewModeFromProps = null}) => {
  const {t} = useTranslation();

  const languages = useSelector(languagesSelector);
  const customLangToCountry = useSelector(appConfigSelector)?.customLangToCountry;

  const viewModeFromConfig = useSelector(themeConfigShowLangsAsTextSelector)
    ? I18N_ADORNMENT_VIEW_MODE_TEXT
    : I18N_ADORNMENT_VIEW_MODE_ICON;

  const [anchorEl, setanchorEl] = useState(null);
  const handleOpen = event => {
    setanchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setanchorEl(null);
  };

  const langToCountry = useMemo(() => {
    const res = {};
    (languages || []).forEach(langCode =>
      CountryLanguage.getLanguageCountries(langCode, (err, countries) => {
        if (!err) {
          res[langCode] =
            customLangToCountry?.[langCode] ||
            countries.find(({code_2}) => code_2.toLowerCase() === langCode)?.code_2.toLowerCase() ||
            countries[0]?.code_2?.toLowerCase();
        }
      })
    );
    return res;
  }, [languages, customLangToCountry]);

  const getLangIcon = useCallback(
    lang =>
      langToCountry[lang] ? (
        <span className={`fi fi-${langToCountry[lang]}`} style={{width: 24}} />
      ) : (
        <span>{lang}</span>
      ),
    [langToCountry]
  );

  const viewMode = viewModeFromProps || viewModeFromConfig;

  return (
    <>
      <Tooltip title={tooltip}>
        {viewMode === I18N_ADORNMENT_VIEW_MODE_ICON ? (
          <IconButton onClick={handleOpen} aria-label={ariaLabel}>
            {getLangIcon(value)}
          </IconButton>
        ) : (
          <Button
            onClick={handleOpen}
            startIcon={viewMode === I18N_ADORNMENT_VIEW_MODE_ICONTEXT ? <Language /> : null}
            endIcon={<ArrowDropDown />}
            aria-label={ariaLabel}
            classes={{
              endIcon: "button-select__menu-button__end-icon"
            }}
            sx={{
              background: Boolean(anchorEl) ? "#f5f5f5" : undefined
            }}
          >
            {getLanguageTranslations(value, t)}
          </Button>
        )}
      </Tooltip>

      <Menu
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
        onClose={handleClose}
        keepMounted
      >
        {languages.map(lang => (
          <MenuItem
            key={lang}
            onClick={() => {
              onChange(lang);
              handleClose();
            }}
          >
            {viewMode === I18N_ADORNMENT_VIEW_MODE_ICON ? getLangIcon(lang) : getLanguageTranslations(lang, t)}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default I18nInputAdornmentSelect;
